import { render } from "./AppImageDraggable.vue?vue&type=template&id=b5fb69a4&scoped=true"
import script from "./AppImageDraggable.vue?vue&type=script&lang=js"
export * from "./AppImageDraggable.vue?vue&type=script&lang=js"

import "./AppImageDraggable.vue?vue&type=style&index=0&id=b5fb69a4&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5fb69a4"]])

export default __exports__